var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m7.4 15c0-11 30.2-11 30.2 0",
  fill: "none",
  stroke: "#333a45",
  strokeWidth: 2.6,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 5.4,
  y: 13.5,
  width: 4,
  height: 7,
  rx: 1.8,
  fill: "#333a45"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 6.2,
  y: 14.5,
  width: 2.4,
  height: 5,
  rx: 1.2,
  fill: "#4fb3c6"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 35.6,
  y: 13.5,
  width: 4,
  height: 7,
  rx: 1.8,
  fill: "#333a45"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 36.4,
  y: 14.5,
  width: 2.4,
  height: 5,
  rx: 1.2,
  fill: "#4fb3c6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m7.4 20.5c0 3.5 3 5.5 6.5 5.5",
  fill: "none",
  stroke: "#333a45",
  strokeWidth: 1.4,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.2,
  cy: 26,
  r: 1.1,
  fill: "#4fb3c6"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 12,
  width: 15,
  height: 10,
  rx: 3.2,
  fill: "#5a8fd8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m18.5 21.3h5.2l-6.9 5z",
  fill: "#5a8fd8"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 17,
  r: 1.1,
  fill: "#ffffff"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 17,
  r: 1.1,
  fill: "#ffffff"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 17,
  r: 1.1,
  fill: "#ffffff"
});

function SvgTechSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechSupport);
export default __webpack_public_path__ + "static/media/tech-support.0e2abfd6350101181c99290ff8da0896.svg";
export { ForwardRef as ReactComponent };